module.exports = __webpack_public_path__ + "img/pinpai.63d9f7b0.png";